import React, { forwardRef, useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isValidCPF } from "../../utils/cpfValidator";
import {
	applyCepMask,
	applyCpfCnpjMask,
	applyPhoneMask,
	applyRgMask,
} from "../../utils/masks";
import ToolTip from "../Tooltip/Tooltip";
import "./Input.css";
import { isValidCNPJ, normalizarCnpj } from "../../utils/cnpjValidator";
import { isValidRG } from "../../utils/rgValidator";

const Input = forwardRef((props, ref) => {
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		setError(props.error);
	}, [props.error]);

	const handleChange = (e) => {
		let { value } = e.target;

		if (!props.externalMask) {
			const normalized = normalizarCnpj(value);

			if (props.showCpfCnpjMask) {
				value = applyCpfCnpjMask(value, normalized.length <= 11);
			} else if (props.showPhoneMask) {
				value = applyPhoneMask(value);
			} else if (props.mask === "CEP") {
				value = applyCepMask(value);
			} else if (props.showRgMask) {
				value = applyRgMask(value);
			}

			e.target.value = value;

			if (props.showCpfCnpjMask || props.showCpfMask) {
				if (normalized.length <= 11) {
					setError(
						isValidCPF(normalized)
							? ""
							: "CPF inválido"
					);
				} else {
					setError(
						isValidCNPJ(normalized)
							? ""
							: "CNPJ inválido"
					);
				}
			}

			if (props.showRgMask) {
				setError(
					isValidRG(value)
						? ""
						: "RG inválido"
				);
			}
		}

		props.onChange?.(e);
	};

	return (
		<label
			className="input-label"
			style={{
				display: props.hidden ? "none" : "flex",
			}}
		>
			{props.labelText && (
				<div
					className="input-tooltip-container"
					style={{
						width: "100%",
						textAlign: "left",
						color: props.disabled
							? "var(--textColorDisabled)"
							: "var(--textColor)",
					}}
				>
					{props.labelText}

					<ToolTip
						tooltipVisible={props.tooltipVisible}
						tooltipText={props.tooltipText}
					/>
				</div>
			)}

			<div className="input-wrapper">
				<input
					ref={ref}
					min={props.min}
					max={props.max}
					minLength={props.minLength}
					maxLength={props.maxLength}
					name={props.name}

					// IMPORTANTE:
					// IMask controla o value
					{...(!props.externalMask && {
						value: props.value || "",
					})}

					onChange={handleChange}
					placeholder={props.placeholder}
					className={`${props.className || "input-form"} ${error ? "input-error" : ""
						} ${props.classNameLabel || ""} ${error ? "border-red-500!" : ""
						} disabled:opacity-50! disabled:cursor-not-allowed!`}
					onKeyDown={props.onKeyPress}
					type={
						props.type === "password" && showPassword
							? "text"
							: props.type || "text"
					}
					autoComplete={props.autoComplete}
					required={props.required || false}
					disabled={props.disabled || false}
					readOnly={props.readOnly || false}
					onClick={props.onClick}
					style={{
						backgroundColor: "var(--inputBackgroundColor)",
						boxShadow: props.disabled
							? "none"
							: "var(--inputBoxShadow)",
						color: props.disabled
							? "var(--inputColorDisabled)"
							: "var(--inputColor)",
						opacity: props.disabled ? "0.5" : "1",
						...props.style,
					}}
				/>

				{props.type === "password" &&
					(props.showablePassword == null ||
						props.showablePassword) && (
						<button
							type="button"
							className="eye-icon"
							onClick={() =>
								setShowPassword(!showPassword)
							}
						>
							{showPassword ? (
								<FaEyeSlash />
							) : (
								<FaEye />
							)}
						</button>
					)}
			</div>

			{error && (
				<span className="error-message">
					{error}
				</span>
			)}
		</label>
	);
});

Input.displayName = "Input";

export default Input;
